
import {Component, Watch} from "vue-property-decorator";
import {getModule} from "vuex-module-decorators";
import {CustomerModule, ShopModule, store, TradeInModule} from "@returns-centre/store";
import {mixins} from 'vue-class-component';
import {FormatDateMixin} from '@returns-centre/mixins';
import {getItemImage} from '@returns-centre/utils';
import {VueModal} from "@/components";

import {
    AppButtonSelection,
    TradeInProductRegistrationQuestionsModal,
    TradeInItemAddedModal,
    TradeInSelectProductFromCategoryModal
} from "@returns-centre/components";

@Component({
    components: {
        AppButtonSelection,
        VueModal,
        TradeInProductRegistrationQuestionsModal,
        TradeInItemAddedModal,
        TradeInSelectProductFromCategoryModal
    }
})
export default class TradeInProductRegister extends mixins(FormatDateMixin) {
    customerModule = getModule(CustomerModule, store);
    shopModule = getModule(ShopModule, store);
    tradeInModule = getModule(TradeInModule, store);
    categories: Category[] | null = [];
    category: Category | null = null;
    productOption: ProductOption | null = null;
    hasTradeInItemAddedModal: boolean = false;
    registerAnotherProductModal: boolean = false;
    formIncomplete: boolean = false;
    tradeInProductRecord: TradeInProductRecord = {
        name: '',
        location: '',
        condition: '',
        retailer_name: '',
        estimated_age: '',
        credit_offered: 0,
        weight: 0,
        weight_unit: '',
        category: '',
        category_parent: '',
        additional_information: '',
        reward_type: 'store-credit',
        variant: null,
        shopify_variant_id: null,
        reward_value: 0,
        image_url: '',
        product_option_id: null,
    };
    hasProductRegistrationQuestionsModal: boolean = false;
    hasOption: boolean = false;
    selectedRetailOption: string = '';
    retailName: string = '';
    otherRetailer: boolean = false;

    async created() {
        this.tradeInModule.reset();
        this.tradeInModule.resetLocalStorage();
        await this.tradeInModule.fetchCategories();
        this.categories = this.tradeInModule.getCategories;

        this.hasTradeInItemAddedModal = false;
        this.hasProductRegistrationQuestionsModal = false;
        this.registerAnotherProductModal = false;

        if (this.categories?.length === 1) {
            this.selectCategory(this.categories[0]);
        }
    }

    onTradeInProductRegistrationQuesitonsModalClose() {
        this.hasProductRegistrationQuestionsModal=false;

        if(this.tradeInModule.tradeInSelectedItemsCount > 0) {
            this.hasTradeInItemAddedModal=true;
        }

    }

    openSummary() {
        this.$emit('open-summary');
        this.hasTradeInItemAddedModal = false;
    }

    hasTradeInLimitReached(): boolean {
        return this.tradeInModule.hasTradeInItemsLimitReached(this.shopModule.shop!.trade_in_items_limit)
    }

    selectProduct(productOption: ProductOption) {
        if(this.hasTradeInLimitReached()) {
            this.hasTradeInItemAddedModal = true;
            return;
        }
        this.productOption = productOption;
        this.hasProductRegistrationQuestionsModal = true;
    }

    selectCategory(category: Category) {
        if(this.hasTradeInLimitReached()) {
            this.hasTradeInItemAddedModal = true;
            return;
        }

        this.category = category;
        this.hasOption = this.category && this.category.product_options_enabled;
        this.$emit('hasOptions', this.hasOption)
    }

    reset() {
        this.productOption = null;
        this.formIncomplete = false;
        this.hasProductRegistrationQuestionsModal = false;
        this.retailName = '';
        this.otherRetailer = false;
        this.selectedRetailOption = '';
        this.tradeInProductRecord = {
            name: '',
            location: '',
            condition: '',
            retailer_name: '',
            estimated_age: '',
            credit_offered: 0,
            weight: 0,
            weight_unit: '',
            category: '',
            category_parent: '',
            additional_information: '',
            reward_type: 'store-credit',
            variant: null,
            shopify_variant_id: null,
            reward_value: 0,
            image_url: '',
            product_option_id: null
        };
    }

    isNullEmpty(string: string | null | undefined) {
        return string == null || string.match(/^ *$/);
    }

    inCurrentCategory() {
        this.registerAnotherProductModal = false;
    }

    withNewCategory() {
        if(this.hasTradeInLimitReached()) {
            this.hasTradeInItemAddedModal = true;
            return;
        }

        this.category = null;
        this.registerAnotherProductModal = false;
        this.hasOption = false;
        this.$emit('hasOptions', this.hasOption)
    }

    prev() {
        this.$emit('prev');
        this.hasTradeInItemAddedModal = false;
    }

    next() {
        this.hasTradeInItemAddedModal = false;
        this.$emit('next');
    }

    getCategoryImage(category: Category): string | null {
        return getItemImage(
            category,
            this.shopModule.shop?.product_image as string,
            this.shopModule.shop?.show_category_images);
    }

    getProductImage(product: ProductOption): string | null {
        return getItemImage(
            product,
            this.shopModule.shop?.product_image as string,
            this.shopModule.shop?.show_product_images);
    }

    get bloodline() {
        let bloodline: Category[] = [];
        if (this.categories && this.category && this.category.path) {

            const parts = this.category.path.split('.');
            let categories = this.categories;
            for (const part of parts) {
                const category = categories.find(item => item.id === parseInt(part));
                if (!category) {
                    break;
                }
                bloodline.push(category)
                categories = category?.children || [];
            }
        }

        return bloodline;
    }

    get breadcrumbs() {
        let breadcrumbs = [];

        breadcrumbs.push({
            label: "all",
            category: null
        });

        for (const category of this.bloodline) {
            breadcrumbs.push({
                label: category.name,
                category
            })
        }

        return breadcrumbs;
    }

    get categoryPath() {
        return this.bloodline
            .map(category => category.name)
            .join(' / ')
    }

    get showProductOptions() {
        return this.category
            && this.category.product_options_enabled
            && this.category.product_options
            && this.category.product_options.length;
    }
}
